"use strict";

var _check_private_redeclaration = require("./_check_private_redeclaration.cjs");

exports._ = exports._class_private_field_init = _class_private_field_init;
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration._(obj, privateMap);
    privateMap.set(obj, value);
}
